<template>
  <section>

<!--    <div class="columns">
      <div class="column">
        <b-field label="Origen del dato">
          <b-input v-if="project.validation_attributes!=null" readonly v-model="project.validation_attributes.data_source"></b-input>
          <b-input v-else readonly></b-input>
        </b-field>
      </div>
    </div>
    <hr class="dropdown-divider" aria-role="menuitem">-->
    <div class="columns">
      <div class="column">
        <h3 class="is-size-6 has-text-weight-bold">
          Dueña(o)
          <b-tooltip label="Solo la/el usuaria/o que es Dueña o Dueño de esta actividad académica tiene permisos para editar todos sus atributos.
                      Quienes participan en la actividad académica pero no son dueños, solo pueden editar su participación."
                     position="is-right"
                     size="is-large"
                     multilined>
            <b-icon
                pack="fas"
                icon="info-circle"
                size="is-small"
                type="is-info">
            </b-icon>
          </b-tooltip>
        </h3>
        <b-field label=" ">
          <b-input v-if="project.owner!=''" readonly v-model="project.owner"></b-input>
          <b-input v-else readonly></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Correo">
          <b-input v-if="project.owner_mail!=''" readonly v-model="project.owner_mail"></b-input>
          <b-input v-else readonly></b-input>
        </b-field>
      </div>
    </div>
  </section>

</template>

<script>
export default {
  name: "AdditionalInformationTab",
  props:['project'],
}
</script>
